import React from 'react'
import { PrevButton, NextButton, usePrevNextButtons } from './emblaCarouselArrowButtons'
import { SelectedSnapDisplay, useSelectedSnapDisplay } from './emblaCarouselSelectedSnapDisplay'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

const EmblaCarousel = (props) => {
  const { children, options } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay({ playOnInit: options.autoplay, delay: options.speed })])
  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi)
  const { selectedSnap, snapCount } = useSelectedSnapDisplay(emblaApi)

  return (
    <div className='flex flex-col md:flex-row pb-10'>
      <div className='embla__buttons px-6 mx-auto'>
        <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
        <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
      </div>
      <section className='embla'>
        <div className='embla__viewport' ref={emblaRef}>
          <div className='embla__container'>{children}</div>
        </div>

        <div className='embla__controls px-6 md:px-0'>
          <SelectedSnapDisplay selectedSnap={selectedSnap} snapCount={snapCount} />
        </div>
      </section>
    </div>
  )
}

export default EmblaCarousel
